import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateLabelComponent } from './date-label.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [DateLabelComponent],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    DateLabelComponent
  ]
})
export class DateLabelModule { }
